import { Box, Text, VStack, HStack, IconButton } from '@chakra-ui/react';
import { ArrowLeft } from 'lucide-react';

export default function PhoneNumberPage() {
  return (
    <Box bg="white" minH="100vh">
      <HStack px={4} py={3}>
        <IconButton aria-label="Back" icon={<ArrowLeft />} variant="ghost" />
        <Text fontWeight="semibold">Phone number</Text>
      </HStack>

      <VStack px={4} mt={6} align="stretch">
        <Text fontSize="lg">+263 77X XXX XXX</Text>
        <Text fontSize="sm" color="gray.500">
          This number is linked to your WhatsApp Business account and cannot be
          changed.
        </Text>
      </VStack>
    </Box>
  );
}
